import { setDimensionType } from "store/features/enlarge/actions";
import { enlargeSelector } from "store/features/enlarge/selectors/enlargeSelector";
import { EnlargeState } from "store/features/enlarge/types";
import { useAppSelector, useAppDispatch } from "store/store";
import { Dimension } from "store/types/resizeSettings";

export const useDimensionTypes = () => {
    const {
        resizeSettings: { dimensionType },
    } = useAppSelector(enlargeSelector, equalityFn);
    const dispatch = useAppDispatch();

    const handleClick = (dimensionType: Dimension) => {
        dispatch(setDimensionType(dimensionType));
    };

    return { handleClick, dimensionType };
};

const equalityFn = (
    left: EnlargeState,
    right: EnlargeState
) => {
    if (
        left.resizeSettings.dimensionType !== right.resizeSettings.dimensionType
    )
        return false;

    return true;
};
